import React from "react";
import { Box } from "@mui/material";
import "./RotatingImage.css";
import natalImage from '../assets/images/natal.png';

const RotatingImage: React.FC = () => (
    <Box className="rotatingWrapper" sx={{ width: '100%', height: '100%' }}>
        <img src={natalImage} alt="Natal Chart" className="rotatingImage" />
    </Box>
);

export default RotatingImage;
